import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { BookingSpace } from '../../domain/models/space.model';
import { BookingSpaceRepository } from '../../domain/repositories/space.repository';
import {BookingSpaceApiService} from "../services/space/space-api.service";
import {SpacesApiMockService} from "../services/space/space-api-mock.service";
import {BookingSpaceStorageService} from "../services/space/space-storage.service";


@Injectable({ providedIn: 'root' })
export class BookingSpaceRepositoryAdapter implements BookingSpaceRepository {

  private readonly storageService = inject(BookingSpaceStorageService);
  private readonly apiService = environment.production
    ? inject(BookingSpaceApiService)
    : inject(SpacesApiMockService);

  getAllSpaces(): Observable<BookingSpace[]> {
    return this.apiService.getAll().pipe(
      switchMap(spaces =>
        this.storageService.save(spaces).pipe(
          map(() => spaces)
        )
      ),
      catchError(() => this.storageService.getAll())
    );
  }

  getSpaceById(id: string): Observable<BookingSpace | null> {
    return this.storageService.getById(id);
  }

  saveSpace(space: BookingSpace): Observable<boolean> {
    return this.apiService.update(space).pipe(
      switchMap(success => {
        if (success) {
          return this.updateSpaceInStorage(space).pipe(
            map(() => true)
          );
        }

        return of(false);
      })
    );
  }

  private updateSpaceInStorage(space: BookingSpace): Observable<BookingSpace[]> {
    return this.storageService.getAll().pipe(
      map(cached => cached.map(cachedSpace =>
        cachedSpace?.id === space?.id ? space : cachedSpace
      )),
      switchMap(updated => this.storageService.save(updated))
    );
  }

  clearAllSpaces(): Observable<void> {
    return this.storageService.clear();
  }
}
